var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCartLgIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100px",
    height: "100px",
    viewBox: "0 0 100 100",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "48235A76-13FB-478C-9C41-7C6F3D9B6DBC") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "TurnItBlue---Milestone-2",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "14.0_Store-Template_07.1",
    transform: "translate(-782.000000, -279.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "02.Icons-/-Basic-/-Line-/-Shopping-/-Cart",
    transform: "translate(782.000000, 279.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M33.3333333,75 C28.75,75 25.0416667,78.75 25.0416667,83.3333333 C25.0416667,87.9166667 28.75,91.6666667 33.3333333,91.6666667 C37.9166667,91.6666667 41.6666667,87.9166667 41.6666667,83.3333333 C41.6666667,78.75 37.9166667,75 33.3333333,75 Z M8.33333333,8.33333333 L8.33333333,16.6666667 L16.6666667,16.6666667 L31.6666667,48.2916667 L26.0416667,58.5 C25.375,59.6666667 25,61.0416667 25,62.5 C25,67.0833333 28.75,70.8333333 33.3333333,70.8333333 L83.3333333,70.8333333 L83.3333333,62.5 L35.0833333,62.5 C34.5,62.5 34.0416667,62.0416667 34.0416667,61.4583333 L34.1666667,60.9583333 L37.9166667,54.1666667 L68.9583333,54.1666667 C72.0833333,54.1666667 74.8333333,52.4583333 76.25,49.875 L91.1666667,22.8333333 C91.5,22.25 91.6666667,21.5416667 91.6666667,20.8333333 C91.6666667,18.5416667 89.7916667,16.6666667 87.5,16.6666667 L25.875,16.6666667 L21.9583333,8.33333333 L8.33333333,8.33333333 Z M75,75 C70.4166667,75 66.7083333,78.75 66.7083333,83.3333333 C66.7083333,87.9166667 70.4166667,91.6666667 75,91.6666667 C79.5833333,91.6666667 83.3333333,87.9166667 83.3333333,83.3333333 C83.3333333,78.75 79.5833333,75 75,75 Z",
    id: "Shape",
    fill: "#CACFD3"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCartLgIcon);
export default __webpack_public_path__ + "static/media/CartLgIcon.42dcf7c4a974e30c8beec1c301777ea6.svg";
export { ForwardRef as ReactComponent };